<template>
  <a-modal v-model="modal" title="打印排单明细" width="920px" :maskClosable="false">
    <div class="print-scheduling-detail-modal">
      <div v-if="loading" class="loading-wrap">
        <a-spin />
      </div>
      <PrintSchedulingDetail v-show="!loading" ref="previewRef" idPrefix="processSchedulingPreviewQrCode" />
      <div class="display-none">
        <PrintSchedulingDetail ref="printRef" id="processSchedulingPrintDetailId" idPrefix="processSchedulingPrintQrCode" />
      </div>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal = false">取消</a-button>
        <a-button type="primary" :loading="loading" @click="handlePrint">确认打印</a-button>
        <a-button ref="printBtn" v-show="false" v-print="'#processSchedulingPrintDetailId'">打印排单明细</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import PrintSchedulingDetail from './print-scheduling-detail.vue'
import { apiMesProcessSchedulingPrintDetail } from '@/api/mes/workOrderManage/ouKangOrderScheduling'

export default {
  name: 'PrintSchedulingDetailModal',
  components: {
    PrintSchedulingDetail
  },
  data () {
    return {
      modal: false,
      loading: false,
      dataList: []
    }
  },
  methods: {
    show (rows) {
      const ids = rows.map(row => row.id).filter(Boolean).join(',')
      if (!ids) {
        return this.$message.warning('请选择有效单据')
      }
      this.dataList = []
      this.modal = true
      this.loading = true
      apiMesProcessSchedulingPrintDetail(ids).then(res => {
        this.dataList = Array.isArray(res.data) ? res.data : []
        this.$nextTick(() => {
          this.$refs.previewRef.show(this.dataList)
        })
      }).catch(err => {
        this.$message.error(err?.msg || err?.message || '获取打印排单明细失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handlePrint () {
      this.$refs.printRef.show(cloneDeep(this.dataList))
      setTimeout(() => {
        this.$refs.printBtn.$el.dispatchEvent(new MouseEvent('click'))
      }, 200)
    }
  }
}
</script>

<style scoped lang="less">
.print-scheduling-detail-modal {
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  padding: 0 15px;
}

.loading-wrap {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 30px 50px;
  margin: 20px 0;
}

.display-none {
  display: none;
}
</style>
